import { canViewDigitadorReport } from './digitadorReportPermission';
import { canViewFinanceiroReport } from './financeiroReportPermission';
import { canViewInspecaoReport } from './inspecaoReportPermission';

/**
 * Links para relatórios BI na listagem NSIRs.
 * Usa os mesmos critérios do menu V2 (supervisor, env, module config) — não role alone.
 */
export function getNsirBiReportLinks({ authData, userRole }) {
  const links = [];

  if (canViewInspecaoReport({ authData, userRole })) {
    links.push({ label: 'Relatório de Inspeção', href: '/v2/relatorio-inspecao' });
  }
  if (canViewDigitadorReport({ authData, userRole })) {
    links.push({ label: 'Relatórios Digitadores', href: '/v2/relatorio-digitacao' });
  }

  return links;
}

/**
 * Permissões de exportação na listagem NSIRs V2.
 * Exports BI seguem canView*; exports operacionais admin permanecem isAdmin.
 */
export function getNsirExportPermissions({ authData, userRole, moduleConfigurations, isAdmin }) {
  return {
    inspecao: canViewInspecaoReport({ authData, userRole }),
    digitador: canViewDigitadorReport({ authData, userRole }),
    financeiro: canViewFinanceiroReport({ authData, userRole, moduleConfigurations }),
    edit: isAdmin,
    servico: isAdmin,
    usoMutuo: isAdmin,
  };
}
